module.exports = __webpack_public_path__ + "img/workArea.8c245182.png";